<div class="rpc-modal">
  <!-- Header -->
  <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200">
    <div class="flex items-center gap-2">
      <mat-icon style="color:#1C593D;">tune</mat-icon>
      <h2 class="text-lg font-bold text-gray-800">Rail Perú — Precio al cliente</h2>
    </div>
    <button (click)="close()" class="text-gray-400 hover:text-gray-700"><mat-icon>close</mat-icon></button>
  </div>

  <div class="px-5 py-4 overflow-y-auto" style="max-height:75vh;">

    <div *ngIf="error" class="mb-3 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">{{ error }}</div>
    <div *ngIf="okMsg" class="mb-3 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-200 text-sm text-emerald-700">✓ {{ okMsg }}</div>

    <!-- Ofrecer USD→PEN (master del rail) -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 mb-4 p-4 flex items-center justify-between gap-3">
      <div>
        <div class="font-bold text-sm" style="color:#1e5a3f;">Ofrecer USD→PEN al cliente</div>
        <div class="text-xs text-gray-500 mt-0.5">Maestro del destino Perú. Si lo apagás, no se ofrece USD→PEN.</div>
      </div>
      <button type="button" (click)="usdtPenOfrecido = !usdtPenOfrecido" [disabled]="saving"
        [style.background]="usdtPenOfrecido ? '#1C593D' : '#cbd5e1'"
        style="position:relative;width:52px;height:30px;border:none;border-radius:999px;cursor:pointer;flex-shrink:0;transition:background .2s;">
        <span [style.left]="usdtPenOfrecido ? '25px' : '3px'"
          style="position:absolute;top:3px;width:24px;height:24px;border-radius:50%;background:#fff;transition:left .2s;"></span>
      </button>
    </div>

    <!-- Estrategia -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-4">
      <div style="background:linear-gradient(135deg,#f0fdf4,#ecfdf5);padding:12px 16px;border-bottom:2px solid #bbf7d0;">
        <h3 class="font-bold text-sm" style="color:#1e5a3f;">Estrategia de precio</h3>
      </div>
      <div class="p-4 flex flex-col gap-3">
        <label class="flex items-start gap-3 p-3 rounded-xl border cursor-pointer"
          [class.border-emerald-400]="pais.estrategia === 'ESPEJO'" [class.bg-emerald-50]="pais.estrategia === 'ESPEJO'"
          [class.border-gray-200]="pais.estrategia !== 'ESPEJO'">
          <input type="radio" name="estrategia" value="ESPEJO" [(ngModel)]="pais.estrategia" (ngModelChange)="onFormChange()" class="mt-1" />
          <span>
            <span class="font-semibold text-sm text-gray-800">🪞 Igualar a Vita automáticamente (sin perder)</span>
            <span class="block text-xs text-gray-500 mt-0.5">
              El cliente recibe lo MISMO que en Vita, en vivo. Si igualar dejara menos que el margen mínimo, flota apenas
              arriba — <strong>nunca a pérdida</strong>. Requiere que Vita publique su oferta pública de Perú.
            </span>
          </span>
        </label>

        <label class="flex items-start gap-3 p-3 rounded-xl border cursor-pointer"
          [class.border-emerald-400]="pais.estrategia === 'A'" [class.bg-emerald-50]="pais.estrategia === 'A'"
          [class.border-gray-200]="pais.estrategia !== 'A'">
          <input type="radio" name="estrategia" value="A" [(ngModel)]="pais.estrategia" (ngModelChange)="onFormChange()" class="mt-1" />
          <span class="flex-1">
            <span class="font-semibold text-sm text-gray-800">💼 Comisión propia (Modelo A)</span>
            <span class="block text-xs text-gray-500 mt-0.5">Tasa de referencia intacta + tu comisión.</span>
            <span *ngIf="pais.estrategia === 'A'" class="flex gap-3 mt-2">
              <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Comisión %
                <input type="number" step="0.01" min="0" [(ngModel)]="pais.comisionPct" (ngModelChange)="onFormChange()" name="comisionPct"
                  class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm w-28" /></label>
              <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Fijo USD
                <input type="number" step="0.01" min="0" [(ngModel)]="pais.fijoUsd" (ngModelChange)="onFormChange()" name="fijoUsd"
                  class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm w-28" /></label>
            </span>
          </span>
        </label>

        <label class="flex items-center gap-3 text-sm font-semibold text-gray-700">
          Nunca ganar menos de
          <input type="number" step="0.01" min="0" [(ngModel)]="pais.margenMinUsd" (ngModelChange)="onFormChange()" name="margenMinUsd"
            class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm w-24" />
          USD por operación
        </label>
      </div>
    </div>

    <!-- Tabla comparativa EN VIVO -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-4">
      <div style="background:linear-gradient(135deg,#eff6ff,#eef2ff);padding:12px 16px;border-bottom:2px solid #bfdbfe;" class="flex items-center justify-between">
        <h3 class="font-bold text-sm" style="color:#1e40af;">Así queda vs Vita (en vivo, antes de guardar)</h3>
        <span *ngIf="previewLoading" class="text-xs text-gray-400">calculando…</span>
      </div>
      <div class="p-4">
        <div *ngIf="preview?.publicaStale" class="mb-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-700">
          ⚠️ La oferta pública de Vita no está disponible ahora. En "Igualar a Vita" el sistema degrada solo a comisión propia mientras tanto.
        </div>
        <div *ngIf="espejoDegradado && !preview?.publicaStale" class="mb-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-700">
          ⚠️ Espejo degradado: sin oferta retail viva de Vita, estas cotizaciones salen por comisión propia.
        </div>
        <div *ngIf="hayClamp" class="mb-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-700">
          ⚠️ El margen mínimo impide igualar a Vita en los montos marcados — el cliente recibe MENOS que en Vita.
        </div>

        <p class="text-xs font-bold mb-1" style="color:#1e5a3f;">
          Interbancario (CCI)
          <span class="font-normal text-gray-400">· tasa Aguacate {{ partner() ? (partner() | number:'1.4-4') : '—' }} · fee {{ fee() != null ? (fee() | number:'1.2-2') : '—' }} PEN · {{ dias() != null ? dias() + 'd' : '—' }}</span>
        </p>
        <table class="w-full text-sm">
          <thead>
            <tr class="text-[11px] text-gray-400 text-left">
              <th class="py-1 font-semibold">Envía USD</th>
              <th class="py-1 font-semibold text-right">Vita da (PEN)</th>
              <th class="py-1 font-semibold text-right">Damos (PEN)</th>
              <th class="py-1 font-semibold text-right">Ganancia</th>
              <th class="py-1 font-semibold text-center">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let it of items" class="border-t border-gray-100">
              <td class="py-1.5 font-semibold text-gray-700">{{ it.montoUsd | number:'1.0-0' }}</td>
              <td class="py-1.5 text-right text-gray-600">{{ it.ofertaVitaLocal != null ? (it.ofertaVitaLocal | number:'1.2-2') : '—' }}</td>
              <td class="py-1.5 text-right font-bold" style="color:#1e5a3f;">{{ recibeDe(it) != null ? (recibeDe(it) | number:'1.2-2') : '—' }}</td>
              <td class="py-1.5 text-right" [style.color]="(gananciaDe(it) || 0) > 0 ? '#1e40af' : '#b91c1c'">
                {{ gananciaDe(it) != null ? (gananciaDe(it) | number:'1.2-2') : '—' }}
              </td>
              <td class="py-1.5 text-center text-xs">
                <ng-container *ngIf="it.quote.disponible && recibeDe(it) != null; else noDisp">
                  <span *ngIf="!margenOkDe(it)" class="text-red-600">🔴 no se ofrece</span>
                  <span *ngIf="margenOkDe(it) && clampedDe(it)" class="text-amber-600">⚠️ bajo Vita ({{ difVsVita(it) | number:'1.2-2' }})</span>
                  <span *ngIf="margenOkDe(it) && !clampedDe(it) && difVsVita(it) != null && difVsVita(it)! >= 0" class="text-emerald-600">✓ igualada</span>
                  <span *ngIf="margenOkDe(it) && !clampedDe(it) && difVsVita(it) != null && difVsVita(it)! < 0" class="text-amber-600">{{ difVsVita(it) | number:'1.2-2' }} vs Vita</span>
                  <span *ngIf="margenOkDe(it) && !clampedDe(it) && difVsVita(it) == null" class="text-gray-400">sin ref. Vita</span>
                </ng-container>
                <ng-template #noDisp><span class="text-red-600">🔴 {{ it.quote.motivo || 'no disponible' }}</span></ng-template>
              </td>
            </tr>
            <tr *ngIf="!items.length"><td colspan="5" class="py-2 text-xs text-gray-400">{{ previewLoading ? 'calculando…' : 'sin datos' }}</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Avanzado -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-4">
      <button (click)="mostrarAvanzado = !mostrarAvanzado" class="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold text-gray-600">
        <span>⚙️ Avanzado — contingencia (tasa manual, costo fijo)</span>
        <mat-icon class="text-gray-400">{{ mostrarAvanzado ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div *ngIf="mostrarAvanzado" class="px-4 pb-4 grid grid-cols-2 gap-2">
        <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Modo tasa
          <select [(ngModel)]="avanzado.modoTasa" name="modoTasa" class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm">
            <option value="AUTO">AUTO (vivo)</option><option value="MANUAL">MANUAL</option>
          </select></label>
        <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Costo fijo PEN
          <input type="number" step="0.01" [(ngModel)]="avanzado.costoFijoLocal" name="costoFijo"
            class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm" /></label>
        <ng-container *ngIf="avanzado.modoTasa === 'MANUAL'">
          <label class="flex flex-col text-xs font-semibold text-amber-700 gap-1">Tasa manual (PEN/USD)
            <input type="number" step="0.0001" [(ngModel)]="avanzado.tasaCostoManual" name="tasaManual" class="border border-amber-300 rounded-lg px-2 py-1.5 text-sm" /></label>
          <label class="flex flex-col text-xs font-semibold text-amber-700 gap-1">Vence
            <input type="datetime-local" [(ngModel)]="avanzado.tasaManualVigenteHasta" name="vence" class="border border-amber-300 rounded-lg px-2 py-1.5 text-sm" /></label>
        </ng-container>
      </div>
    </div>

    <!-- Motivo + Guardar -->
    <div class="flex items-end gap-3">
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1 flex-1">Motivo (opcional)
        <input type="text" [(ngModel)]="pais.motivo" name="motivo" class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm" /></label>
      <button (click)="saveAll()" [disabled]="saving || loading" class="px-5 py-2 rounded-lg text-white text-sm font-semibold" style="background:#1C593D;">
        {{ saving ? 'Guardando…' : 'Guardar' }}
      </button>
    </div>
    <p class="text-[11px] text-gray-400 mt-2">
      La <strong>activación</strong> del país es el toggle del catálogo Vita. Cada Guardar crea una versión nueva (auditable).
      <span *ngIf="config?.responsible"> Últ. cambio: {{ config?.responsible }}.</span>
    </p>
  </div>
</div>
